import React, { useState } from "react";
import { Modal } from "antd";
import UserLeaderListing from "../DropdownsListing/UserLeaderListing";

interface roleModelProps {
  handleConfirmRoleModel?: () => void;
  type?: string;
  handleModelFunction?: () => void;
  roleId?: number;
  setUserId?: any;
}

const ChangeRoleModel: React.FC<roleModelProps> = ({
  handleConfirmRoleModel,
  type,
  handleModelFunction,
  roleId,
  setUserId,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null); // Replace 'any' with correct type if available

  const isConfirmDisabled = !isChecked || !selectedUser;

  return (
    <Modal
      centered
      open={true}
      onCancel={handleConfirmRoleModel}
      className="custom-modal-col"
    >
      <div className="text-center">
        <div className="text-center mb-3">
          <h1>Change {roleId === 2 ? "Leader" : "Controller"}</h1>
        </div>
        <UserLeaderListing
          roleType={roleId}
          dataToSet={{}}
          onSelect={(user) => (setSelectedUser(user), setUserId(user))}
        />

        <div className="mt-3 mb-3">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
          <span className="text-white ml-3">Continue with this change?</span>
        </div>

        <button
          className="gradient-button py-[15px] px-[80px] rounded-md text-[12px] 2xl:text-sm w-full"
          onClick={() => handleModelFunction?.()}
          disabled={isConfirmDisabled}
        >
          Confirm
        </button>

        <button
          className="btn-secondary bg-transparent border-0 text-[#48BA89] text-sm mt-[30px]"
          onClick={handleConfirmRoleModel}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default ChangeRoleModel;
